export default __webpack_public_path__ + "static/img_canimed-1187df386ca8be34535599b81d084d7a.png";